module.exports = __webpack_public_path__ + "media/images/pic/certificates/about-us/2-9e1d809891a657d5bc3cd0e01284da61.jpg";